import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/hooks/use-auth";
import { useProfile } from "@/hooks/use-profile";

type ProtectedRouteProps = {
  children: React.ReactNode;
  adminOnly?: boolean;
};

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, adminOnly = false }) => {
  const { user, ready, role, isDisabled } = useAuth();
  const { profile, loading: profileLoading } = useProfile();
  const location = useLocation();

  if (!ready) {
    return (
      <div className="flex min-h-[50vh] items-center justify-center text-muted-foreground">
        Carregando...
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (isDisabled) {
    return <Navigate to="/disabled" replace />;
  }

  const effectiveRole = (profile?.role ?? role) || null;
  if (adminOnly) {
    if (profileLoading) {
      return (
        <div className="flex min-h-[50vh] items-center justify-center text-muted-foreground">
          Carregando...
        </div>
      );
    }
    if (effectiveRole !== "admin") {
      return <Navigate to="/" replace />;
    }
  }

  return <>{children}</>;
};

export default ProtectedRoute;